<template>
  <div class="point record-path-point">
    <div class="point__details">
      <div class="point__details__info">
        <div class="point__details__info__person">
          <div class="name">{{ name }}</div>
          <div class="dot" v-if="name && mobile">•</div>
          <div class="mobile">{{ mobile }}</div>
        </div>
      </div>
      <div class="point__details__address">
        {{ address }}
        <span class="point__details__address-remarks" v-if="remarks"
          >&nbsp;•&nbsp;{{ remarks }}</span
        >
      </div>
      <div class="d-flex justify-start align-center">
        <div class="point__details__cod" v-if="cod">
          <span>{{ $t('dropoff_address.form.cod') }}: </span>
          <span class="cod">{{ formattedCOD }}</span>
        </div>

        <v-tooltip
          v-if="deliverToDoor.visible"
          right
          :disabled="!deliverToDoor.label"
          content-class="v-tooltip__custom-content"
          max-width="210"
        >
          <div slot="activator" class="point__details__d2d-tag">
            {{ $t('dropoff_address.deliver_to_door') }}
          </div>
          <span>{{ deliverToDoor.label }}</span>
        </v-tooltip>
      </div>
      <div class="point__details__tracking-number" v-if="trackingNumber">
        <span>{{ $t('tracking_number') }}: </span>
        <span>{{ trackingNumber }}</span>
      </div>

      <div class="point__details__return-package-receive-time" v-if="returnPackageReceiveVisible">
        <p v-if="confirmReturnTime > 0">
          {{
            $t('dropoff_address.form.return_package_received', { time: formatConfirmReturnTime })
          }}
        </p>

        <v-tooltip v-else top content-class="v-tooltip__custom-content">
          <v-btn
            slot="activator"
            :disabled="loading"
            :loading="loading"
            @click="returnPackageReceived"
            small
            depressed
            flat
            class="secondary"
            >{{ $t('dropoff_address.form.return_package_receive_button') }}</v-btn
          >
          <span style="white-space: nowrap">
            {{ $t('dropoff_address.form.return_package_receive_button_hint') }}
          </span>
        </v-tooltip>
      </div>
    </div>
    <slot></slot>
    <PointLink
      :icon="icon"
      :hiddenTail="hiddenLinkTail"
      :havMargin="false"
      iconSize="10"
      :left="'-19px'"
    />
  </div>
</template>

<script>
import PointLink from '@/components/new_order_v2/order_path/PointLink'
import { formatTimeCalendar } from '@/plugins/util'

export default {
  name: 'Point',
  props: {
    dropoff: {
      type: Boolean,
      default: false
    },
    hiddenLinkTail: {
      type: Boolean,
      default: false
    },
    address: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    cod: {
      default: ''
    },
    mobile: {
      type: String,
      default: ''
    },
    remarks: {
      type: String,
      default: ''
    },
    trackingNumber: {
      type: String,
      default: ''
    },
    aptNumber: {
      type: String,
      default: ''
    },
    building: {
      type: String,
      default: ''
    },
    status: {
      type: String,
      default: ''
    },
    pointIndex: {
      type: Number
    },
    orderRequests: {
      type: Array
    },
    confirmReturnTime: {
      type: Number
    },
    loadingPointIndex: {
      type: Number
    },
    isSumaryOrder: {
      type: Boolean,
      default: false
    }
  },
  components: {
    PointLink
  },
  computed: {
    formatConfirmReturnTime() {
      const time = this.confirmReturnTime
      console.log('formatConfirmReturnTime', time)
      return time > 0 ? formatTimeCalendar(time) : 0
    },
    formattedCOD() {
      let result
      const numCOD = typeof this.cod === 'string' ? parseInt(this.cod) : this.cod
      if (numCOD > 0) {
        result = `${this.$constants.CURRENCY_CONFIG.prefix}${numCOD.toLocaleString()}`
      }
      return result
    },
    icon() {
      if (this.dropoff) {
        if (this.status) {
          if (this.status === this.$constants.ORDER_STATUS.FAILED) return 'DO Fail'
          if (this.status === this.$constants.ORDER_STATUS.COMPLETED) return 'DO Complete'
        }

        return 'DO Simple'
      } else {
        return 'PU Simple'
      }
    },
    loading() {
      return this.loadingPointIndex === this.pointIndex
    },
    returnPackageReceiveVisible() {
      const profile = this.$store.getters.userProfile
      return (
        profile &&
        profile.tags &&
        profile.tags.includes(this.$constants.RO_EXPERT) &&
        this.status === this.$constants.ORDER_STATUS.FAILED
      )
    },
    deliverToDoor() {
      const requests = this.orderRequests || []
      const foundIndex = requests.findIndex((r) => r.path_index === this.pointIndex)
      const visible = foundIndex >= 0
      let label = this.aptNumber ? this.aptNumber : ''
      label += label ? ' • ' : ''
      label += this.building ? this.building : ''

      return {
        visible,
        label
      }
    }
  },
  methods: {
    returnPackageReceived() {
      this.$emit('returnPackageReceived', this.pointIndex)
    }
  }
}
</script>

<style lang="scss" scoped>
.point {
  position: relative;
  display: flex;
  align-items: center;
  line-height: 20px;
  margin-left: 20px;

  .point__details {
    flex: 1;
    border-radius: 4px;
    padding: 12px 3px;
    font-size: 14px;

    .point__details__info {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      .point__details__info__person {
        display: inline-flex;
        font-weight: 500;

        .dot {
          padding: 0 3px;
        }

        .name {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          max-width: 250px;
        }
      }
    }

    .point__details__address {
      color: #7a8189;
      margin-top: 2px;

      .point__details__address-remarks {
        display: block;
        word-break: break-word;
        font-size: 14px;
      }
    }

    .point__details__cod {
      margin-top: 2px;
      max-width: 120px;
      display: inline-block;
      vertical-align: middle;

      .info-icon {
        display: inline-block;
        vertical-align: text-top;
        margin-left: 6px;
      }

      span {
        color: #7a8189;
      }

      .cod {
        color: #007cff;
        font-weight: 500;
      }
    }

    .point__details__tracking-number {
      margin-top: 2px;
      color: #7a8189;
    }

    .point__details__return-package-receive-time {
      margin-top: 2px;
      color: #7a8189;

      .v-btn {
        margin: 0;
        text-transform: initial;
        background: #eee;
      }

      p {
        color: #1dc05e;
        margin: 0;
      }
    }

    .point__details__d2d-tag {
      background: rgba(255, 130, 0, 0.08);
      border-radius: 4px;
      color: #ff8200;
      padding: 0 7px;
      display: inline-block;
      vertical-align: middle;
      font-weight: 500;
      font-size: 12px;
      margin-top: 5px;
    }
  }
}
</style>

<style lang="scss">
$point_height_half: 5px;

.record-path-point {
  .point-link {
    top: 20px !important;

    .point-link__dash {
      height: calc(100% - 28px);
      margin-top: 10px;
    }
  }

  .point-pink__icon {
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
